import mobile from 'is-mobile';
import { useMemo } from 'react';

export const useIsMobile = (req) => {
  const isUserAgentMobile = mobile({ ua: req });
  const isUserAgentTablet = mobile({ ua: req, tablet: true, featureDetect: true });
  return useMemo(() => isUserAgentMobile || isUserAgentTablet, [isUserAgentMobile, isUserAgentTablet]);
};
